// SidebarMenu.js

import React, { useEffect, useState } from "react";


import styled from "styled-components";

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button
} from '@mui/material';
import { Input } from '@mui/material';

const StyledFormContainer = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;


const FileUploader = ({ uploadFile, setSelectedFile, selectedFile, progress, setProgress, showAlert, setShowAlert }) => {
  useEffect(() => {
  }, [])

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    const fileExt = file.name.split('.').pop();
    console.log('file', file)
    console.log('type',  file.type)
    // if(file.type != 'application/pdf' ){
    //   alert('jpg 파일만 Upload 가능합니다.');
    //   return;
    // }
    // setProgress(0);
    setSelectedFile(e.target.files[0]);
  }

  


  return (
     <div>
        {/* <Button> 파일 선택 </Button> */}
        {/* <div>{JSON.stringify(selectedFile?.name)}</div> */}
        {/* <div> {progress} </div> */}
        <Input color="primary" type="file" onChange={handleFileInput}/>
        {/* <Button onClick={() => uploadFile(selectedFile)}> 업로드 </Button> */}

    </div>
    
  );
};

export default FileUploader;
